import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateCurrentRenderedQueryString')(function updateCurrentRenderedQueryString(
    recipientWell: FindControlViewState,
    currentRenderedQueryString: string
) {
    recipientWell.currentRenderedQueryString = currentRenderedQueryString;
});
